'use client'

import { useEffect, useState } from 'react'

import { IS_SYNERISE_RECOMMENDATION_ENABLED } from 'lib/synerise/config'
import { waitForSyneriseClientUUID } from 'lib/synerise/sdk'

/**
 * React hook for accessing the Synerise UUID from window.SyneriseTC or Synerise window.SR, once it's available.
 * Returns { uuid, loading }
 */
export function useSyneriseUUID() {
  const [syneriseClientUUID, setSyneriseClientUUID] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!IS_SYNERISE_RECOMMENDATION_ENABLED) {
      setLoading(false)

      return
    }

    let mounted = true

    waitForSyneriseClientUUID()
      .then(id => {
        if (mounted) {
          setSyneriseClientUUID(id ?? '')
          setLoading(false)
        }
      })
      .catch(() => {
        if (mounted) {
          setSyneriseClientUUID('')
          setLoading(false)
        }
      })

    return () => {
      mounted = false
    }
  }, [])

  return { syneriseClientUUID, loading }
}
